import { withHeuristicTrunkZero } from "@eudonet/opal";
/**
 * Defensive mapping of the accessible-applications payload: the wire type is
 * unchecked, so anything malformed (non-array, entry without a usable code) is
 * dropped rather than propagated. Server order is preserved — the list arrives
 * sorted by `order` and is never re-sorted here; a missing/non-numeric `order`
 * falls back to the entry's index to keep the invariant.
 */
function mapAccessibleApplications(raw) {
    if (!Array.isArray(raw)) {
        return [];
    }
    return raw.reduce((acc, entry, index) => {
        if (entry && typeof entry === "object") {
            const { code, order } = entry;
            if (typeof code === "string" && code.trim() !== "") {
                acc.push({ code: code.trim(), order: typeof order === "number" ? order : index });
            }
        }
        return acc;
    }, []);
}
export function mapResponseToProfile(data) {
    // OPUS persists the national number stripped of its trunk zero (OP-7665: strict E.164 storage
    // split across two fields rather than one string). Reconstruct it heuristically for the
    // EDITABLE field's initial value, same as every other add/edit surface on reopen — otherwise a
    // French/UK/Dutch/German/Belgian/Swiss profile number always reloads without its leading 0.
    const phoneNumber = withHeuristicTrunkZero((data.phoneCountryCode || "") + (data.phoneNationalNumber || ""));
    return {
        fullName: data.userName ||
            `${data.firstName || ""} ${data.lastName || ""}`.trim(),
        profilePicture: data.avatarUri || "",
        email: data.email || "",
        firstName: data.firstName || "",
        surname: data.lastName || "",
        phoneNumber: phoneNumber,
        phoneCountryCode: data.phoneCountryCode || "",
        phoneNationalNumber: data.phoneNationalNumber || "",
        department: data.department || "",
        jobTitle: data.jobTitle || "",
        displayLanguage: data.locale || "en-GB",
        timeZone: data.timeZoneId || "Europe/Paris",
        timeFormat: data.timeFormat || "24",
        dateFormat: data.dateFormat || "DD/MM/YYYY",
        workspaceTimeZone: data.workspaceTimeZoneId || undefined,
        // Transitional fallback: an older BFF still sends hubPermissions only. Remove the
        // fallback together with the BFF legacy alias once both sides are deployed (OP-6659).
        permissions: Array.isArray(data.permissions)
            ? data.permissions
            : Array.isArray(data.hubPermissions)
                ? data.hubPermissions
                : [],
        accessibleApplications: mapAccessibleApplications(data.accessibleApplications),
        defaultApplicationCode: typeof data.defaultApplicationCode === "string" && data.defaultApplicationCode.trim() !== ""
            ? data.defaultApplicationCode.trim()
            : null,
    };
}
